export const getPreviousStepIndex = (
  firstVisibleIndex: number,
  step: number,
) => (firstVisibleIndex < step ? 0 : firstVisibleIndex - step);

export const getNextStepIndex = (
  lastVisibleIndex: number,
  itemCount: number,
  step: number,
) => {
  const lastIndex = itemCount - 1;
  return lastIndex - lastVisibleIndex < step
    ? lastIndex
    : lastVisibleIndex + step;
};

export const findLastIndex = (
  items: Element[],
  predicate: (item: Element) => boolean,
) => {
  for (let index = items.length - 1; index >= 0; index -= 1) {
    if (predicate(items[index])) {
      return index;
    }
  }
  return -1;
};

export const scrollContainerToItem = (
  item: Element,
  container: HTMLElement | null,
  step?: number,
) => {
  if (!container) {
    return;
  }
  const containerBox = container.getBoundingClientRect();
  const itemBox = item.getBoundingClientRect();
  const styles = getComputedStyle(container);
  const viewStart =
    containerBox.left + (Number.parseFloat(styles.paddingLeft) || 0);
  const viewEnd =
    containerBox.right - (Number.parseFloat(styles.paddingRight) || 0);

  let delta = 0;
  if (step === 1) {
    delta = itemBox.left + itemBox.width / 2 - (viewStart + viewEnd) / 2;
  } else if (itemBox.left < viewStart) {
    delta = itemBox.left - viewStart;
  } else if (itemBox.right > viewEnd) {
    delta = itemBox.right - viewEnd;
  }

  if (delta !== 0) {
    container.scrollLeft += delta;
  }
};
